import type { WorkOrderObjectData, WorkOrderPriceItem, WorkOrderVersionSeasonData } from 'gql/graphql';
import { WorkOrderPriceTypeEnum } from 'gql/graphql';
import { useProjectData } from 'hooks/useProjectData';
import { Button, IconExpand, Loader } from 'uikit';

import type { ICellRendererParams } from 'ag-grid-community/dist/types/core/rendering/cellRenderers/iCellRenderer';
import * as R from 'ramda';
import { useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';

import { WorkOrderVersionObjectTotals } from './WorkOrderVersionObjectTotals';

type WorkOrderVersionMenuCellRendererProps = ICellRendererParams<WorkOrderPriceItem> & {
    seasons: WorkOrderVersionSeasonData[];
    workOrderObjects?: WorkOrderObjectData[] | null;
    versionId: number;
};

export const WorkOrderVersionMenuCellRenderer = (props: WorkOrderVersionMenuCellRendererProps) => {
    const { data, seasons, workOrderObjects, versionId } = props;

    const { id: projectId } = useParams();
    const { projectData } = useProjectData(projectId, false);

    const [isObjectTotalsOpen, setIsObjectTotalsOpen] = useState<boolean>(false);

    const onSwitchObjectTotalsVisibility = useCallback(() => {
        setIsObjectTotalsOpen(R.not);
    }, []);

    if (!data) {
        return <Loader />;
    }

    if (data?.type === WorkOrderPriceTypeEnum.OtherGroup) {
        return null;
    }

    if (data?.type === WorkOrderPriceTypeEnum.RootObject) {
        return (
            <>
                <Button
                    iconLeft={IconExpand}
                    onlyIcon
                    view="clear"
                    size="xs"
                    onClick={onSwitchObjectTotalsVisibility}
                />
                {isObjectTotalsOpen && (
                    <WorkOrderVersionObjectTotals
                        onClose={onSwitchObjectTotalsVisibility}
                        rowData={data}
                        costRounding={
                            projectData?.contractNavigation?.data?.contractNavData?.metadata?.costRounding ?? 0
                        }
                        versionId={versionId}
                        seasons={seasons}
                        workOrderObjects={workOrderObjects}
                    />
                )}
            </>
        );
    }

    return null;
};

WorkOrderVersionMenuCellRenderer.displayName = 'WorkOrderVersionMenuCellRenderer';
